import React from "react";
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IAppState } from "../state/interfaces";
import { connect } from "react-redux";

interface IProps extends RouteComponentProps {

}

class Footer extends React.Component<IProps, any> {

    constructor(props: IProps) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <div className="footer">
                    <p>
                        U.S. Insurance Services, LLC, a California limited liability company is doing business as "Onward Insurance Services"
                        ("Onward") licensed as an insurance agency. Insurance policies sold through Onward are placed with and underwritten
                        by KnightBrook Insurance Company (NAIC #13722), which is a corporate affiliate of Onward and Westlake Financial, and
                        are only available in California (License No. 6005640) and Texas (License No. 2911238). Savings on insurance vary based
                        on coverages and rating factors and the terms of the insurance policy, if issued, will set forth the coverage provided.
                    </p>
                </div>
            </div>
        );
    }
}

let mapProps = (state: IAppState, ownProps: any) => {
    return {
    }
}

let mapDispatch = (dispatch: any) => {
    return {
    }
}

export default withRouter(connect(mapProps)(Footer))
